import { Component } from '@angular/core';

@Component({
  selector: 'app-pan-action-bar',
  templateUrl: './pan-action-bar.component.html',
  styleUrl: './pan-action-bar.component.scss',
  standalone: false,
})
export class PanActionBarComponent {}
